/**
 * The app's effective dark state for an Apple map's `colorScheme`: a forced
 * `data-theme` (Night Tube sets `dark`) overrides the OS preference. MapKit
 * JS does not follow the app theme by itself (unlike iOS/Android map views).
 */
export function resolveMapDark(): boolean {
  if (typeof document === 'undefined') return false
  const forced = document.documentElement.dataset.theme
  if (forced === 'dark') return true
  if (forced === 'light') return false
  return typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches
}
